import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMessageSquare } from "react-icons/fi";
import { useParams } from "react-router-dom";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import LateCheckoutTimePicker from "../CheckIn/Addon/LateCheckoutTimePicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import { baseUrl } from "../../Environments/environment";
import axios from "axios";
import {
  addSelectedAddOn,
  filterAddOnRequests,
  filterCheckInOutRequsts,
  addExtendStayStatus,
  setLateCheckOutTime,
  setGuestCheckInOutRequests,
  setGuestAddons,
} from "../../redux/addOn/addOnSlice";
import { Tick } from "../../icons/Tick";
import timezones from "../../data/timezone";
import { motion } from "framer-motion";
import { FaRegHandshake } from "react-icons/fa6";
import RatingDisplay from "../Rating/Rating";
import "./modal.css";
import google from "../../Assets/google.png";
import onelyk from "../../Assets/onelyk.png";
import yelp from "../../Assets/yelp.png";
import tripadvisor from "../../Assets/tripadvisor.png";
import booking from "../../Assets/booking.png";
import expedia from "../../Assets/expedia.png";
import agoda from "../../Assets/agoda.png";
import { ThreeDot } from "react-loading-indicators";

const convert24to12 = (time24) => {
  try {
    return moment(time24, "HH:mm").format("hh:mm A");
  } catch (error) {
    console.error("Error converting 24h to 12h format:", error);
    return "";
  }
};

// Convert 12-hour format to 24-hour format
const convert12to24 = (time12) => {
  try {
    return moment(time12, "hh:mm A").format("HH:mm");
  } catch (error) {
    console.error("Error converting 12h to 24h format:", error);
    return "";
  }
};

function extractWindowsTimeZone(fullString) {
  if (!fullString) return null;
  return fullString.split(" (")[0].trim();
}

function convertUTCToLocal(utcDateString, propertyTimeZoneString) {
  if (!utcDateString) return "";
  if (!propertyTimeZoneString) {
    return moment.utc(utcDateString).format("MMMM DD, YYYY - h:mm A [UTC]");
  }

  const windowsTz = extractWindowsTimeZone(propertyTimeZoneString);
  const ianaTz = timezones[windowsTz];

  if (!windowsTz || !ianaTz) {
    console.warn("Unknown time zone:", propertyTimeZoneString);
    return moment.utc(utcDateString).format("MMMM DD, YYYY - h:mm A [UTC]");
  }

  return moment.utc(utcDateString).tz(ianaTz).format("MMMM DD, YYYY - h:mm A");
}

function formatDateTime(dateTimeString) {
  if (!dateTimeString) return "";

  try {
    const date = moment.utc(dateTimeString);
    if (!date.isValid()) return "Invalid Date";

    const formattedDate = date.format("MMMM DD, YYYY");
    const formattedTime = date.format("h:mm A");

    return (
      <div className="flex flex-col">
        <span>{formattedDate}</span>
        <span>{formattedTime}</span>
      </div>
    );
  } catch (error) {
    console.error("Error formatting date time:", error);
    return dateTimeString;
  }
}

const Modal = ({
  guest,
  propertyLateCheckOutTime,
  propertyCheckOutTime,
  selectedTime,
  selectedDate,
  setSelectedTime,
  setSelectedDate,
  addOns,
  propertyMobile,
}) => {
  const navigate = useNavigate();
  // const guestSessionId = `66c72f7c8610d881b822af9d`;
  // const [currentStatus, setCurrentStatus] = useState("");
  // const [checkIn, setCheckIn] = useState("");
  // const [checkOut, setCheckOut] = useState("");
  const guestid = useParams();
  const dispatch = useDispatch();
  const guestSessionId = guestid.id;
  const [property, setProperty] = useState(null);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState(null);
  const [reviewFlow, setReviewFlow] = useState([]);
  const [initialRating, setInitialRating] = useState(0); // Track initial rating that triggered review
  const [showInternalReview, setShowInternalReview] = useState(false); // Controls whether to show rating form
  const [showThankYouMessage, setShowThankYouMessage] = useState(false); // Show thank you after internal review

  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const [propertyTimeZone, setPropertyTimeZone] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isExtendStayModalOpen, setIsExtendStayModalOpen] = useState(false);
  const [requestStatus, setRequestStatus] = useState(null);
  const [extendStayRequestStatus, setExtendStayRequestStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isExtendStayLoading, setIsExtendStayLoading] = useState(false);
  const [confirmLateCheckOutRequest, setConfirmLateCheckOutRequest] =
    useState(false);
  const [lateCheckOutFlag, setLateCheckOutFlag] = useState(false);
  const [isLateCheckOutLoading, setIsLateCheckOutLoading] = useState(false);
  const [extendStaySelectDate, setExtendStaySelectDate] = useState(null);
  const [lateCheckoutRequestStatus, setlateCheckoutRequestStatus] =
    useState(null);
  const storeGuest = useSelector((state) => state.guest);
  const [ratingLoading, setRatingLoading] = useState(false);
  const [pendingRating, setPendingRating] = useState(null);
  const [progressiveFill, setProgressiveFill] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  const isInternalReviewCompleted = (reviewData = review) => {
    if (!reviewData) return false;

    // Check multiple indicators that internal review was completed:

    // 1. Check if any category ratings (other than overAllRating) exist
    const categoryRatings = [
      "roomRating",
      "serviceRating",
      "locationRating", // Hospitality
      "foodRating",
      "ambienceRating", // Restaurant
      "productQualityRating",
      "valueRating", // Retail
      "treatmentQualityRating",
      "cleanlinessRating",
      "staffProfessionalismRating", // Beauty/Spa
      "qualityRating",
      "responsivenessRating",
      "professionalismRating",
      "cleanupRating", // Home Services
      "knowledgeRating",
      "communicationRating",
      "resultsRating", // Professional Services
      "repairQualityRating",
      "customerServiceRating",
      "waitTimeRating", // Auto Services
      "doctorBehaviorRating",
      "waitingTimeRating",
      "facilityRating", // Medical
      "instructorRating",
      "facilityQualityRating",
      "programValueRating", // Education/Fitness
    ];
    const hasCategory = categoryRatings.some(
      (key) => reviewData[key] && reviewData[key] > 0,
    );

    // 2. Check if comments exist (user filled the internal form)
    const hasComments = reviewData.comments && reviewData.comments.length > 0;

    // 3. Check if tripType or travelWith exist (unique to internal review)
    const hasTripInfo = reviewData.tripType || reviewData.travelWith;

    // 4. Check if hotelDescription array exists
    const hasDescription =
      reviewData.hotelDescription && reviewData.hotelDescription.length > 0;

    // 5. Check if detailedFeedback exists
    const hasDetailedFeedback =
      reviewData.detailedFeedback &&
      ((typeof reviewData.detailedFeedback === "object" &&
        Object.keys(reviewData.detailedFeedback).length > 0) ||
        (typeof reviewData.detailedFeedback === "string" &&
          reviewData.detailedFeedback.length > 0));

    const isCompleted =
      hasCategory ||
      hasComments ||
      hasTripInfo ||
      hasDescription ||
      hasDetailedFeedback;

    return isCompleted;
  };

  // Progressive fill effect
  useEffect(() => {
    if (pendingRating && isAnimating) {
      setProgressiveFill(0);
      let current = 0;
      const interval = setInterval(() => {
        current++;
        setProgressiveFill(current);
        if (current >= pendingRating) {
          clearInterval(interval);
          setTimeout(() => {
            setPendingRating(null);
            setIsAnimating(false);
            handleRating(pendingRating);
          }, 350);
        }
      }, 80);
      return () => clearInterval(interval);
    }
  }, [pendingRating, isAnimating]);

  const storeAddOns = useSelector((state) => state.addOn);
  useEffect(() => {
    if (
      guest &&
      guest.status &&
      guest.status.extendStayStatus &&
      guest.status.extendStayStatus === "Declined"
    ) {
      dispatch(addExtendStayStatus(""));
    }
    if (
      guest &&
      guest.status &&
      guest.status.extendStayStatus &&
      guest.status.extendStayStatus === "Accepted"
    ) {
      console.log("ExtendStayStatus");
    }
  }, []);
  const getGuestCheckInOutRequests = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
      );
      dispatch(setGuestCheckInOutRequests(response.data.result));
      dispatch(filterCheckInOutRequsts(response.data.result));
    } catch (error) {
      console.error("Error fetching guest data:", error);
    }
  };
  const getGuestAddons = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/guestApi/${guestSessionId}/addOns`,
      );
      dispatch(filterAddOnRequests(response.data.result));
      dispatch(setGuestAddons(response.data.result));
    } catch (error) {
      console.error("Error fetching guest data:", error);
    }
  };
  const getWorkFlow = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/guestApi/${guestSessionId}/workflow`,
      );
      console.log("Response", response.data.result.reviewFlow);
      setReviewFlow(response.data.result.reviewFlow);
      localStorage.setItem(
        "reviewFlow",
        JSON.stringify(response.data.result.reviewFlow),
      );

      setPropertyTimeZone(response.data.result.settingFlow.timezone);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  const getReview = async () => {
    try {
      setRatingLoading(true);

      // Fetch both review and workflow in parallel
      const [propertyRes, reviewRes, workflowRes] = await Promise.all([
        axios.get(`${baseUrl}/guestApi/${guestSessionId}/property`),
        axios.get(`${baseUrl}/guestApi/${guestSessionId}/review`),
        axios.get(`${baseUrl}/guestApi/${guestSessionId}/workflow`),
      ]);

      const fetchedProperty = propertyRes.data.result;
      const fetchedReview = reviewRes.data.result.review;
      const fetchedWorkflow = workflowRes.data.result.reviewFlow;

      setProperty(fetchedProperty);
      setReview(fetchedReview);
      setReviewFlow(fetchedWorkflow);
      localStorage.setItem("reviewFlow", JSON.stringify(fetchedWorkflow));

      // If internal review was completed, determine what rating to display
      if (fetchedReview.overAllRating > 0) {
        const isInternal = isInternalReviewCompleted(fetchedReview);

        if (isInternal) {
          // Internal review was completed
          // Check if backend provided initialRating
          if (fetchedReview.initialRating) {
            // Use the initialRating from backend
            setRating(fetchedReview.initialRating);
            setInitialRating(fetchedReview.initialRating);
          } else {
            // Fallback: if current rating is above threshold, user likely changed it
            const currentRatingAboveThreshold =
              fetchedReview.overAllRating >
              fetchedWorkflow.startLimitForReviewLink;

            if (currentRatingAboveThreshold) {
              // User changed rating to high value in internal form
              // Display threshold value as estimate of initial rating
              const displayRating =
                fetchedWorkflow.startLimitForReviewLink || 3;
              setRating(displayRating);
              setInitialRating(displayRating);
            } else {
              // Rating is still low, display as is
              setRating(fetchedReview.overAllRating);
              setInitialRating(fetchedReview.overAllRating);
            }
          }
        } else {
          // No internal review, display actual rating
          setRating(fetchedReview.overAllRating);
        }

        // const hasPendingReviews = fetchedReview?.listing?.some(
        //   (e) => !e.reviewGiven
        // );
        const hasPendingReviews = true;

        // Only show platform buttons if:
        // 1. No internal review was completed (or rating was high from start)
        // 2. Rating is above threshold
        // 3. There are pending platform reviews
        if (
          !isInternal &&
          hasPendingReviews &&
          fetchedWorkflow?.reviewsEnabled &&
          fetchedReview.overAllRating > fetchedWorkflow.startLimitForReviewLink
        ) {
          setIsBottomSheetOpen(true);
        }
      } else {
        setRating(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setRatingLoading(false);
    }
  };
  async function handleSubmiReview(rate) {
    try {
      const response = await axios.patch(
        `${baseUrl}/guestApi/${guestSessionId}/review`,
        { review: rate },
      );
      //console.log("Response", response.data.result);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  }
  useEffect(() => {
    getGuestCheckInOutRequests();
    getGuestAddons();
    getReview();
  }, [requestStatus, lateCheckoutRequestStatus, extendStayRequestStatus]);
  const handleRating = async (rate) => {
    if (!ratingLoading && reviewFlow) {
      setRating(rate);
      setInitialRating(rate);
      setReview((prev) => ({ ...prev, overAllRating: rate }));
      const hasPendingReviews = review?.listing.length > 0;

      if (
        reviewFlow.reviewsEnabled &&
        rate > reviewFlow.startLimitForReviewLink
      ) {
        if (hasPendingReviews) {
          setIsBottomSheetOpen(true);
          const defaultListing = review?.listing?.find((lst) => lst.isDefault);
          if (defaultListing) {
            handleSubmiListingReview(defaultListing);
          } else if (review?.listing?.length === 1) {
            handleSubmiListingReview(review?.listing[0]);
          }
        }
      } else {
        // Show internal review form instead of navigating
        setShowInternalReview(true);
      }
    }
  };
  const closeModal = () => {
    setReviewModalOpen(false);
  };

  const initiateCheckin = () => {
    navigate(`/${guestSessionId}/check-in`);
  };

  const viewAddOns = () => {
    navigate(`/${guestSessionId}/addons`);
  };

  const handleOpenMessagingApp = () => {
    const phoneNumber = propertyMobile; // Include the country code here
    const message = "Hello, I need some help!";
    const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(message)}`;

    window.location.href = smsLink;
  };

  function formatDateandTime(date, time) {
    // If date is a Date object, format it to 'DD-MM-YYYY'
    if (date instanceof Date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      date = `${day}-${month}-${year}`;
    }

    // Try to ensure date is in 'DD-MM-YYYY' format if it's a string
    if (typeof date === "string") {
      const dateParts = date.split("-");
      if (dateParts.length === 3) {
        const [day, month, year] = dateParts;
        // Convert 'DD-MM-YYYY' to 'YYYY-MM-DD'
        date = `${year}-${month}-${day}`;
      } else {
        // If date is not in the expected 'DD-MM-YYYY' format, keep it as it is
        console.warn(
          "Date is not in 'DD-MM-YYYY' format. Using the original date value.",
        );
      }
    } else {
      // If date is not a string and not a Date object, leave it as it is
      console.warn(
        "Date is not in a recognized format. Using the original date value.",
      );
    }

    // Ensure time is a valid string, if not default to '00:00'
    if (typeof time !== "string" || time.trim() === "") {
      time = "00:00";
    }

    // Combine the formatted date and time into a single string in the format 'YYYY-MM-DDTHH:mm:ss'
    const dateTimeString = `${date}T${time}:00`;

    // Return the final formatted date-time string
    return dateTimeString;
  }
  function saveDateTime(dateTimeString) {
    const localMoment = momentTimeZone(dateTimeString);
    const utcDateTime = localMoment.utc().format();

    return utcDateTime;
  }
  function formatDateTime2(date, time) {
    // Convert 'DD-MM-YYYY' to 'YYYY-MM-DD'
    const [day, month, year] = date.split("-");
    const formattedDate = `${year}-${month}-${day}`;

    // Combine the formatted date and time into a single string in the format 'YYYY-MM-DDTHH:mm:ss'
    const dateTimeString = `${formattedDate}T${time}Z`; // 'Z' makes it UTC

    return dateTimeString;
  }
  const handleLateCheckOutAddon = async (time) => {
    const formattedTime = convert12to24(time);
    const data = {
      lateCheckOutDateTime: formatDateTime2(
        moment(guest.checkOut).format("DD-MM-YYYY"),
        formattedTime,
      ),
      requestType: "lateCheckOut",
      checkInOutRequestId: addOns[1]._id,
    };
    try {
      setIsLateCheckOutLoading(true);
      const response = await axios.post(
        `${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
        data,
      );

      if (response.status === 200) {
        setlateCheckoutRequestStatus("success"); // Update the request status to success
        dispatch(addSelectedAddOn(addOns[1]));
        //dispatch(setLateCheckOutTime(time));
        //  console.log("Request sent successfully!");
      } else {
        setlateCheckoutRequestStatus("failure"); // Update the request status to failure
        //  console.log("Request failed. Please try again.");
      }
    } catch (error) {
      setlateCheckoutRequestStatus("failure"); // Update the request status to failure
      console.log(error);
      //toast.error("Request failed. Please try again.");
    } finally {
      setIsLateCheckOutLoading(false); // Ensure loading state is reset
    }
  };
  const handleExtendStay = async (date) => {
    const data = {
      extendStayDateTime: formatDateandTime(date, propertyCheckOutTime),
      requestType: "extendStay",
    };
    try {
      setIsExtendStayLoading(true);
      const response = await axios.post(
        `${baseUrl}/guestApi/${guestSessionId}/checkInOutRequest`,
        data,
      );

      if (response.status === 200) {
        setExtendStayRequestStatus("success"); // Update the request status to success
        // dispatch(addSelectedAddOn(addOns[1]));
        dispatch(addExtendStayStatus("Applied"));
        // console.log("Request sent successfully!");
      } else {
        setExtendStayRequestStatus("failure"); // Update the request status to failure
        //  console.log("Request failed. Please try again.");
      }
    } catch (error) {
      setExtendStayRequestStatus("failure"); // Update the request status to failure
      console.log(error);
      //toast.error("Request failed. Please try again.");
    } finally {
      setIsExtendStayLoading(false); // Ensure loading state is reset
    }
  };
  const handleReviewComplete = async () => {
    // Hide the internal review form
    setShowInternalReview(false);

    // Show thank you message (permanently, no auto-hide)
    setShowThankYouMessage(true);

    // Reload the review data to show locked stars
    try {
      setRatingLoading(true);
      const [reviewRes, workflowRes] = await Promise.all([
        axios.get(`${baseUrl}/guestApi/${guestSessionId}/review`),
        axios.get(`${baseUrl}/guestApi/${guestSessionId}/workflow`),
      ]);

      const fetchedReview = reviewRes.data.result.review;
      const fetchedWorkflow = workflowRes.data.result.reviewFlow;

      setReview(fetchedReview);
      setReviewFlow(fetchedWorkflow);

      // If internal review was completed, determine what rating to display
      if (fetchedReview.overAllRating > 0) {
        const isInternal = isInternalReviewCompleted(fetchedReview);

        if (isInternal) {
          if (fetchedReview.initialRating) {
            setRating(fetchedReview.initialRating);
            setInitialRating(fetchedReview.initialRating);
          } else {
            const currentRatingAboveThreshold =
              fetchedReview.overAllRating >
              fetchedWorkflow.startLimitForReviewLink;

            if (currentRatingAboveThreshold) {
              const displayRating =
                fetchedWorkflow.startLimitForReviewLink || 3;
              setRating(displayRating);
              setInitialRating(displayRating);
            } else {
              setRating(fetchedReview.overAllRating);
              setInitialRating(fetchedReview.overAllRating);
            }
          }
        } else {
          setRating(fetchedReview.overAllRating);
        }
      } else {
        setRating(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setRatingLoading(false);
    }
  };

  const handleReviewCancel = () => {
    // Just hide the internal review form, don't show thank you message
    setShowInternalReview(false);
  };
  async function handleSubmiListingReview(lst) {
    try {
      if (lst?.url) {
        window.open(lst.url, "_blank", "noopener,noreferrer");
      }

      if (!lst.reviewGiven) {
        const updatedListing = review?.listing.map((element) =>
          element.network === lst.network
            ? { ...element, reviewGiven: true, overAllRating: pendingRating }
            : element,
        );
        const updatedReview = {
          ...review,
          overAllRating: pendingRating || review?.overAllRating,
          listing: updatedListing,
        };

        setReview(updatedReview);
        
        axios.patch(`${baseUrl}/guestApi/${guestSessionId}/review`, {
          review: updatedReview,
        }).catch(err => console.error("Error submitting listing review:", err));
      }
    } catch (error) {
      console.error("Error submitting listing review:", error);
    }
  }
  if (ratingLoading) {
    return (
      <div className="min-h-[100svh] grid place-items-center">
        <ThreeDot variant="brick-stack" color="#4f46e5" size="medium" />
      </div>
    );
  }
  return (
    <>
      <div className="overflow-hidden bg-[#F9FAFB] shadow sm:rounded-lg m-5 rounded-xl">
        {rating === 0 && (
          <div className="flex justify-between w-full">
            <div className="px-4 py-2 sm:p-6 flex flex-col items-start">
              <div className="font-poppins text-[#9CA3AF] text-[13px]">
                Current Status
              </div>
              <div
                className={`font-poppins text-[21px] ${
                  guest.status.reservationStatus === "Cancelled"
                    ? "text-red-500"
                    : guest.status.currentStatus === "Reservation"
                      ? "text-[#10B981]"
                      : guest.status.currentStatus === "In House"
                        ? "text-[#F59E0B]"
                        : guest.status.currentStatus === "Cancelled" ||
                            guest.status.currentStatus === "No Show"
                          ? "text-red-500"
                          : "text-[#6366F1]"
                }`}
              >
                {guest.status.reservationStatus === "Cancelled"
                  ? "Reservation Cancelled"
                  : guest.status.currentStatus === "Reservation"
                    ? "Reservation Confirmed"
                    : guest.status.currentStatus}
              </div>
            </div>
            {(guest.status.currentStatus === "In House" ||
              guest.status.currentStatus === "Checked Out") && (
              <div className="px-4 py-2 sm:p-6 flex flex-col items-start">
                <div className="font-poppins text-[#9CA3AF] text-[13px]">
                  Room No
                </div>
                <div className="font-poppins text-[18px]">
                  {guest.roomNumber}
                </div>
              </div>
            )}
          </div>
        )}
        {rating === 0 && (
          <div className="px-4 py-2 sm:p-6 flex sm:justify-start justify-between">
            <div className="flex flex-col items-start pr-3">
              <div className="font-poppins text-[#9CA3AF] text-[13px]">
                {guest.status.earlyCheckInStatus === "Accepted"
                  ? "Early check in"
                  : "Check In"}
              </div>
              <div className="font-poppins text-[#111827] text-[14px]">
                {formatDateTime(guest.checkIn)}
              </div>
            </div>
            <div className="flex flex-col items-start pl-3">
              <div className="font-poppins text-[#9CA3AF] text-[13px]">
                {guest.status.lateCheckOutStatus === "Accepted"
                  ? "Late Check Out"
                  : guest.status.extendStayStatus === "Accepted"
                    ? "Extended Stay"
                    : "Check Out"}
              </div>
              <div className="font-poppins text-[#111827] text-[14px]">
                {formatDateTime(guest.checkOut)}
              </div>
            </div>
          </div>
        )}
        {guest.status.currentStatus === "Reservation" &&
          guest.status.reservationStatus !== "Cancelled" && (
            <div className="px-4 pt-2 pb-5 sm:p-6 flex flex-col items-start space-y-2">
              <div className="font-poppins text-[#9CA3AF] text-[13px]">
                Up Next
              </div>
              {guest.status.preArrivalStatus === "Not Applied" && (
                <button
                  type="button"
                  className="rounded-md bg-[#4F46E5] px-3.5 py-2 font-normal text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 w-full text-[14px]"
                  onClick={initiateCheckin}
                >
                  Online Check In
                </button>
              )}
              <button
                className={
                  guest.status.preArrivalStatus === "Not Applied"
                    ? `w-full py-2 px-3.5 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50 text-[14px] font-normal`
                    : `rounded-md bg-[#4F46E5] px-3.5 py-2 font-normal text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 w-full text-[14px]`
                }
                onClick={viewAddOns}
              >
                View AddOn's
              </button>
              {guest.status.preArrivalStatus === "Applied" && (
                <div className="flex justify-between w-full">
                  <button
                    className="py-2 px-3.5 text-indigo-600 rounded-md hover:bg-indigo-50 text-[14px]"
                    onClick={handleOpenMessagingApp}
                  >
                    <div className="flex space-x-1 items-center justify-center">
                      <FiMessageSquare />
                      <div>Chat with the Front Desk </div>
                    </div>
                  </button>
                  {/* <button
                    className="py-2 px-3.5 text-indigo-600 rounded-md hover:bg-indigo-50 text-[14px]"
                    onClick={() => setReviewModalOpen(true)}
                  >
                    Share Feedback
                  </button> */}
                </div>
              )}
            </div>
          )}
        {guest.status.currentStatus === "In House" && (
          <div className="px-4 pt-2 pb-5 sm:p-6 flex flex-col items-start space-y-2">
            <div className="font-poppins text-[#9CA3AF] text-[13px]">
              Up Next
            </div>
            {propertyLateCheckOutTime && (
              <>
                {storeAddOns &&
                  ((storeAddOns.guestCheckInOutRequests.length > 0 &&
                    !storeAddOns.guestCheckInOutRequests.some(
                      (selectedAddOn) =>
                        selectedAddOn.requestType === "lateCheckOut" &&
                        selectedAddOn.requestStatus !== "Declined",
                    )) ||
                    storeAddOns.guestCheckInOutRequests.length < 1) && (
                    <button
                      type="button"
                      className="rounded-md bg-[#4F46E5] px-3.5 py-2 font-normal text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 w-full text-[14px]"
                      onClick={() => {
                        setLateCheckOutFlag(true);
                        setIsModalOpen(true);
                      }}
                    >
                      Request Late Check out{" "}
                      {propertyLateCheckOutTime.paid &&
                        propertyLateCheckOutTime.price > 0 && (
                          <span> (${propertyLateCheckOutTime.price})</span>
                        )}
                    </button>
                  )}

                {storeAddOns?.guestCheckInOutRequests?.some(
                  (selectedAddOn) =>
                    selectedAddOn.requestType === "lateCheckOut" &&
                    selectedAddOn.requestStatus !== "Declined",
                ) && (
                  <button
                    className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
                    disabled
                  >
                    <span className="mr-2">
                      <Tick />
                    </span>
                    {storeAddOns.guestCheckInOutRequests.find(
                      (selectedAddOn) =>
                        selectedAddOn.requestType === "lateCheckOut",
                    )?.requestStatus === "Accepted"
                      ? "Late Checkout Request Accepted"
                      : "Late Checkout Request Sent"}
                  </button>
                )}
              </>
            )}
            {storeAddOns &&
              ((storeAddOns.guestCheckInOutRequests.length > 0 &&
                !storeAddOns.guestCheckInOutRequests.some(
                  (selectedAddOn) =>
                    selectedAddOn.requestType === "extendStay" &&
                    selectedAddOn.requestStatus !== "Declined",
                )) ||
                storeAddOns.guestCheckInOutRequests.length < 1) && (
                <button
                  type="button"
                  className="rounded-md border-2 border-[#4F46E5] px-3.5 py-2 font-normal text-[#4F46E5] shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 w-full text-[14px]"
                  onClick={() => {
                    setLateCheckOutFlag(false);
                    setIsExtendStayModalOpen(true);
                  }}
                >
                  Extend My Stay
                </button>
              )}
            {storeAddOns?.guestCheckInOutRequests?.some(
              (selectedAddOn) =>
                selectedAddOn.requestType === "extendStay" &&
                selectedAddOn.requestStatus !== "Declined",
            ) && (
              <button
                className="w-full py-2 bg-green-100 text-green-700 rounded-md flex items-center justify-center"
                disabled
              >
                <span className="mr-2">
                  <Tick />
                </span>
                {storeAddOns.guestCheckInOutRequests.find(
                  (selectedAddOn) => selectedAddOn.requestType === "extendStay",
                )?.requestStatus === "Accepted"
                  ? "Extend Stay Request Accepted"
                  : "Extend Stay Request Sent"}
              </button>
            )}

            <div className="flex justify-between w-full">
              <button
                className="py-2 px-3.5 text-indigo-600 rounded-md hover:bg-indigo-50 text-[14px]"
                onClick={handleOpenMessagingApp}
              >
                <div className="flex space-x-1 items-center justify-center">
                  <FiMessageSquare />
                  <div>Chat with the Front Desk </div>
                </div>
              </button>
              <button
                className="py-2 px-3.5 text-indigo-600 rounded-md hover:bg-indigo-50 text-[14px]"
                onClick={() => setReviewModalOpen(true)}
              >
                Share Feedback
              </button>
            </div>
          </div>
        )}
        {(guest.status.currentStatus === "Checked Out" ||
          guest.status.currentStatus === "No Show" ||
          guest.status.reservationStatus === "Cancelled" ||
          reviewModalOpen) && (
          <div className={reviewModalOpen ? "fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-50" : ""}>
            <div className={reviewModalOpen ? "bg-white w-full max-w-md rounded-t-2xl p-6 pb-12 shadow-lg relative" : "w-full"}>
              {reviewModalOpen && (
                <button
                  onClick={() => setReviewModalOpen(false)}
                  className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 z-10"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
              {showInternalReview ? (
              <RatingDisplay
                guest={guest}
                review={review}
                property={property}
                guestSessionId={guestSessionId}
                initialRating={initialRating}
                onComplete={handleReviewComplete}
                onCancel={handleReviewCancel}
              />
            ) : (
              <motion.div
                className="w-full  mt-2 flex flex-col items-center"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
              >
                {/* Rating heading - always shown */}
                <div className="text-base text-gray-700 text-center mb-2 font-medium">
                  Please Rate Your Experience
                </div>
                <motion.div
                  className="text-sm text-gray-500 text-center mb-1"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5, duration: 0.5 }}
                >
                  Choose 1-5 stars. 5 stars is excellent.
                </motion.div>
                <div
                  className="relative flex flex-row justify-center items-center gap-2 mb-3"
                  style={{ minHeight: 44 }}
                >
                  {[1, 2, 3, 4, 5].map((star) => {
                    let isFilled = star <= rating;
                    if (pendingRating && isAnimating) {
                      isFilled = star <= progressiveFill;
                    }
                    return (
                      <motion.svg
                        key={star}
                        onClick={() => {
                          if (
                            !isAnimating &&
                            !review?.listing?.some((e) => e.reviewGiven) &&
                            !isInternalReviewCompleted()
                          ) {
                            // start progressive animation for visual effect
                            setPendingRating(star);
                            setIsAnimating(true);
                          }
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                        fill={isFilled ? "#4F46E5" : "none"}
                        viewBox="0 0 24 24"
                        stroke="#4F46E5"
                        className={`w-10 h-10 z-10 star-glow-hover${
                          isFilled ? " star-glow-theme" : ""
                        }${
                          review?.listing?.some((e) => e.reviewGiven) ||
                          isInternalReviewCompleted()
                            ? " cursor-not-allowed opacity-70"
                            : " cursor-pointer"
                        }`}
                        whileHover={
                          !isAnimating &&
                          rating === 0 &&
                          !review?.listing?.some((e) => e.reviewGiven) &&
                          !isInternalReviewCompleted()
                            ? {
                                scale: 1.22,
                                filter: "drop-shadow(0 0 12px #4F46E5)",
                              }
                            : false
                        }
                        whileTap={
                          !isAnimating &&
                          rating === 0 &&
                          !review?.listing?.some((e) => e.reviewGiven) &&
                          !isInternalReviewCompleted()
                            ? { scale: 1.35 }
                            : false
                        }
                        animate={
                          rating === 0 &&
                          !isAnimating &&
                          !review?.listing?.some((e) => e.reviewGiven) &&
                          !isInternalReviewCompleted()
                            ? {
                                scale: [1, 1.13, 1],
                                filter: isFilled
                                  ? "drop-shadow(0 0 16px #4F46E5)"
                                  : "",
                              }
                            : isFilled
                              ? { filter: "drop-shadow(0 0 16px #4F46E5)" }
                              : {}
                        }
                        transition={
                          rating === 0 && !isAnimating
                            ? {
                                repeat: Infinity,
                                duration: 1.1,
                                type: "tween",
                                ease: "easeInOut",
                              }
                            : { type: "spring", stiffness: 300, damping: 20 }
                        }
                        style={{
                          transition: "fill 0.2s, stroke 0.2s, filter 0.3s",
                        }}
                      >
                        <path
                          strokeLinecap="butt"
                          strokeLinejoin="miter"
                          strokeWidth="1.3"
                          d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.385 4.267a1 1 0 00.95.69h4.486c.969 0 1.371 1.24.588 1.81l-3.625 2.634a1 1 0 00-.364 1.118l1.385 4.267c.3.921-.755 1.688-1.54 1.118L12 17.011l-3.625 2.634c-.784.57-1.84-.197-1.54-1.118l1.385-4.267a1 1 0 00-.364-1.118L4.231 9.694c-.783-.57-.38-1.81.588-1.81h4.486a1 1 0 00.95-.69l1.385-4.267z"
                        />
                      </motion.svg>
                    );
                  })}
                </div>

                {isBottomSheetOpen && (
                  <div className="w-full px-4 max-w-[400px]">
                    <motion.div
                      className="w-full flex flex-col items-center justify-center mt-6 mb-4"
                      initial={{ opacity: 0, y: 40 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.7, ease: "easeOut" }}
                    >
                      {(review?.listing || [])?.length > 0 &&
                      review?.overAllRating !== 0 &&
                      reviewFlow?.reviewsEnabled &&
                      review?.overAllRating >
                        reviewFlow?.startLimitForReviewLink ? (
                        <>
                          <div className="relative w-full flex flex-col justify-center items-center gap-2 mb-3">
                            {review?.listing?.map((lst) => (
                              <button
                                key={lst.network}
                                onClick={() => handleSubmiListingReview(lst)}
                                className="w-full inline-flex items-center justify-center gap-x-1 rounded-md bg-indigo-600 px-3 sm:px-3.5 py-2 sm:py-2.5 text-center text-xs sm:text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-colors whitespace-nowrap"
                                aria-label={`Review on ${lst.network}`}
                                disabled={ratingLoading}
                              >
                                <div className="flex-grow">
                                  {" "}
                                  Review us on{" "}
                                  {lst.network.charAt(0).toUpperCase() +
                                    lst.network.slice(1)}
                                  {""}
                                </div>
                                <div>
                                  <img
                                    src={
                                      lst?.network === "google"
                                        ? google
                                        : lst?.network === "tripadvisor"
                                          ? tripadvisor
                                          : lst?.network === "booking"
                                            ? booking
                                            : lst?.network === "agoda"
                                              ? agoda
                                              : lst?.network === "expedia"
                                                ? expedia
                                                : lst?.network === "yelp"
                                                  ? yelp
                                                  : lst?.network === "onelyk"
                                                    ? onelyk
                                                    : null
                                    }
                                    alt={`${lst.network} icon`}
                                    className="rounded-full  p-0 bg-white "
                                    style={{
                                      height: "24px",
                                      width: "24px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              </button>
                            ))}
                          </div>
                        </>
                      ) : null}
                    </motion.div>
                  </div>
                )}
                {(review?.listing?.some((e) => e.reviewGiven) ||
                  isInternalReviewCompleted() ||
                  showThankYouMessage) && (
                  <div className="text-base text-gray-700 text-center mb-2 font-medium">
                    Thanks for your feedback. Our team will review it shortly.
                  </div>
                )}
              </motion.div>
            )}
            </div>
          </div>
        )}

        {isModalOpen && (
          <div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
            {guest && (
              <LateCheckoutTimePicker
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                setRequestSent={(date, time) => {
                  setSelectedTime(time);
                  // setSelectedDate(date);
                  handleLateCheckOutAddon(time);
                  setConfirmLateCheckOutRequest(true);
                }}
                addon={storeAddOns.allAddOns.find((addon) => {
                  if (
                    addon.addOnType !== "CustomAddon" &&
                    addon.name
                      .toLowerCase()
                      .replace(/\s+/g, "")
                      .includes("late")
                  )
                    return addon;
                })}
                propertyLateCheckOutTime={propertyLateCheckOutTime}
                propertyTime={propertyCheckOutTime}
                checkOutDate={guest.checkOut}
                lateCheckOutFlag={lateCheckOutFlag}
                propertyTimeZone={propertyTimeZone}
              />
            )}
          </div>
        )}
        {isExtendStayModalOpen && (
          <div className="fixed inset-0 bg-gray-700 bg-opacity-70 z-40">
            {guest && (
              <LateCheckoutTimePicker
                isModalOpen={isExtendStayModalOpen}
                setIsModalOpen={setIsExtendStayModalOpen}
                setRequestSent={(date, time) => {
                  setExtendStaySelectDate(date);
                  handleExtendStay(date);
                  setConfirmLateCheckOutRequest(true);
                }}
                propertyLateCheckOutTime={propertyLateCheckOutTime}
                propertyTime={propertyCheckOutTime}
                checkOutDate={guest.checkOut}
                lateCheckOutFlag={lateCheckOutFlag}
                propertyTimeZone={propertyTimeZone}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Modal;
